export const shareConstants = {
  DOMAIN: 'smata.com',
  DEVELOPMENT_ENV_NAME: 'development',
  STAGING_ENV_NAME: 'staging',
  PRODUCTION_ENV_NAME: 'production',
  ROOT_ID: '#__next',
  DEFAULT_PAGE: 1,
  DEFAULT_PER_PAGE: 20,
};
